{
  "name": "ceremabo-front",
  "title": "Ceremabo — Gestion des abonnements",
  "version": "0.1.0",
  "scripts": {
    "ng": "bunx --bun @angular/cli",
    "generate": "bun scripts/processor.ts",
    "start": "bun run generate && (bun run generate -- --watch & bun run ng serve front2 --host 0.0.0.0)",
    "build": "bun run generate && bun run ng build",
    "watch": "bun run ng build --watch --configuration development",
    "test": "bun run ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "bun@1.3.5",
  "dependencies": {
    "@angular/animations": "^21.1.2",
    "@angular/common": "^21.1.2",
    "@angular/compiler": "^21.1.2",
    "@angular/core": "^21.1.2",
    "@angular/forms": "^21.1.2",
    "@angular/platform-browser": "^21.1.2",
    "@angular/platform-browser-dynamic": "^21.1.2",
    "@angular/router": "^21.1.2",
    "@cadriciel/core": "^0.0.5",
    "@jsverse/transloco": "^8.2.0",
    "@jsverse/utils": "^1.0.0-beta.6",
    "@primeng/themes": "^21.0.4",
    "@primeuix/motion": "^0.0.11",
    "@primeuix/styled": "^0.7.4",
    "@primeuix/styles": "^2.0.3",
    "@primeuix/themes": "^2.0.3",
    "@primeuix/utils": "^0.6.4",
    "angular-oauth2-oidc": "^20.0.2",
    "echarts": "^5.6.0",
    "luxon": "^3.5.0",
    "ngx-echarts": "^21.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^21.0.4",
    "quill": "^2.0.3",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.0",
    "zrender": "^6.0.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.1.2",
    "@angular/build": "^21.1.2",
    "@angular/cli": "^21.1.2",
    "@angular/compiler-cli": "^21.1.2",
    "@types/luxon": "^3.5.0",
    "tailwindcss": "^3.4.17",
    "tailwindcss-primeui": "^0.6.1",
    "typescript": "~5.9.2"
  }
}